module.exports = __webpack_public_path__ + "static/media/vn.fea389cb.svg";